// src/pages/DashboardSales.tsx
import React, { useState } from 'react';
import CustomersGrowthChart from '../components/charts/CustomersGrowthChart';
import DailyTransactionChart from '../components/charts/DailyTransactionChart';
import MonthlyTransactionChart from '../components/charts/MonthlyTransactionChart';

const DashboardSales = () => {
  const tabs = [
    'Growth_Customer',
    'Sales_Summary',
    'product',
    'detail',
    'payment'
  ];

  const monthOptions = [...Array(12)].map((_, i) => {
	  const date = new Date();
	  date.setDate(1); // ⬅️ pastikan tanggal jadi 1 (agar aman)
	  date.setHours(0, 0, 0, 0); // ⬅️ pastikan jam jadi 00:00
	  date.setMonth(date.getMonth() - i);

	  const value = `${date.getFullYear()}-${(date.getMonth() + 1)
		.toString()
		.padStart(2, '0')}`;

	  const label = date.toLocaleDateString('id-ID', {
		month: 'long',
		year: 'numeric',
	  });

	  return { value, label };
  });



  const [activeTab, setActiveTab] = useState('Growth_Customer');
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0].value);

  return (
    <div className="p-1">
      {/* Tabs */}
      <div className="flex space-x-0 border-b mb-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium ${
              activeTab === tab
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-600'
            }`}
          >
            {tab.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
          </button>
        ))}
      </div>

      {/* Growth Customer Chart */}
      {activeTab === 'Growth_Customer' && (
        <div className="bg-white p-4 shadow rounded">
          <CustomersGrowthChart />
        </div>
      )}

      {/* Sales Summary Tab */}
      {activeTab === 'Sales_Summary' && (
        <div className="bg-white p-4 shadow rounded">
          <div className="mb-3">
            <label className="mr-2 text-[13px]">Pilih Bulan:</label>
            <select
              className="border rounded px-2 py-1 text-[13px]"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {monthOptions.map(({ value, label }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Daily Transaction Value</h2>
              <DailyTransactionChart month={selectedMonth} />
            </div>

            <div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Monthly Transaction Value</h2>
              <MonthlyTransactionChart month={selectedMonth} />
            </div>
          </div>
        </div>
      )}

      {/* Placeholder Tabs */}
      {['product', 'detail', 'payment'].includes(activeTab) && (
        <div className="bg-white p-4 shadow rounded">
          <h2 className="text-lg font-semibold">
            {activeTab.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
          </h2>
          <p className="text-gray-500">(coming soon)</p>
        </div>
      )}
    </div>
  );
};

export default DashboardSales;
